import {
	AnimationClip,
	NumberKeyframeTrack,
} from 'three';

const _ = require('lodash');

const fps = 60;
const partsToAnimate = ['Wolf3D_Head', 'Wolf3D_Teeth'];


function createAnimation (recordedData, nodeWithBlendShapes) {
  if (recordedData.length == 0) return null;

  const { morphTargetDictionary } = nodeWithBlendShapes;

  const animation = Object.keys(morphTargetDictionary).map( k => [] );
  
  const timeArray = [];
  recordedData.forEach((d, finishedFrames) => {
    Object.entries(d.blendshapes).forEach(([key, value]) => {
      if (! (key in morphTargetDictionary)) {
        return;
      };
      
      // adjustment makes the upper teeth more visible
      if (key == 'mouthShrugUpper') {
        value += 0.4;
      }

      animation[morphTargetDictionary[key]].push(value)
    });
    timeArray.push(finishedFrames / fps)
  });

  //create morph animation
  const allTracks = [];
  Object.entries(recordedData[0].blendshapes).forEach(([key, value]) => {
    if (! (key in morphTargetDictionary)) {
      // should never happen, see above!
      return;
    };

    const targetIndex = morphTargetDictionary[key];

    const newTracks = partsToAnimate.map(
      partName => new NumberKeyframeTrack(`${partName}.morphTargetInfluences[${targetIndex}]`, timeArray, animation[targetIndex])
    );
    
    allTracks.push(...newTracks);
  });

  const clip = new AnimationClip('animation', -1, allTracks);
  return clip;
}

export default createAnimation;